import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Notes from './index';
import NoteDetail from './NoteDetail';
import { getNoteCategories } from '../../api/notes';

/**
 * `/notes/{한 조각}` 이 카테고리 허브인지 글 상세인지 가른다.
 *
 * 노트 경로를 평면(`/notes/{slug}`)으로 정한 대가다(03 §2-2·§2-3). 카테고리가 바뀌어도
 * 글 주소가 죽지 않는 대신, 글 slug 와 카테고리 slug 가 같은 자리를 다툰다.
 * 그 충돌은 `cms.reserved_slugs` 가 막고(카테고리 4종이 예약돼 있다), 여기서는
 * **카테고리 목록에 있으면 허브, 없으면 글**로 가른다.
 *
 * 라우터 경로로 가를 수 없는 이유는 두 경우의 모양이 완전히 같기 때문이다.
 * 판단 근거가 데이터에 있으므로 판단도 데이터를 받아서 한다.
 */
const NotesSegment = () => {
    const { segment } = useParams();
    const [isCategory, setIsCategory] = useState(null); // null = 아직 모름

    useEffect(() => {
        let alive = true;
        setIsCategory(null);
        getNoteCategories()
            .then((cats) => { if (alive) setIsCategory(cats.some((c) => c.slug === segment)); })
            // 카테고리 목록을 못 받으면 글로 본다. 글이 아니면 상세가 "찾을 수 없음"을 낸다.
            .catch(() => { if (alive) setIsCategory(false); })
            .finally(() => {});
        return () => { alive = false; };
    }, [segment]);

    if (isCategory === null) {
        return <div className="notes-page"><div className="container notes-empty">불러오는 중…</div></div>;
    }
    return isCategory ? <Notes /> : <NoteDetail slug={segment} />;
};

export default NotesSegment;
